var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:({ 
    cursor: 'url(' + _vm.pointerCursor + '), auto',
    margin: 0
    })},[_c('nav',{staticClass:"navbar navbar-expand-md fixed-top"},[_vm._m(0),_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item nav-secondary"},[_c('router-link',{staticClass:"nav-link title-font",attrs:{"to":"/about"}},[_vm._v("About")])],1)])]),_c('BackgroundImage',{attrs:{"name":"Home","galleries":_vm.galleries,"showLabels":this.showLabels}}),_c('DetailViewer',{attrs:{"items":_vm.items,"scaling":_vm.scaling,"imgSize":_vm.imgSize,"isVisible":this.showLabels}}),_c('transition',{attrs:{"name":"fade"}},[(_vm.fadeFullscreenText)?_c('div',{staticClass:"container-fluid align-items-center p-0 m-0 fade-text",style:({ 
        pointerEvents: 'none',
        top: 0,
        left: 0,
        transitionDelay: '2s',
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        margin: 0
      })},[_c('div',{staticClass:"row align-items-center justify-content-center p-0",style:({ 
          width: '100vw',
          height: '100vh',
          margin: 0
        })},[_c('div',{staticClass:"col-md-4 p-0"},[_c('h2',[_vm._v("Press 'F11' in Windows or 'Command-Shift-F' in Mac for a full experience.")])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item nav-main mr-0"},[_c('div',{staticClass:"nav-link"},[_vm._v("Misalignments")])])])}]

export { render, staticRenderFns }